import React, { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { ExpandedRowProvider } from './ExpandedRowContext';

interface AnimatedTableProps {
    children: ReactNode;
    className?: string;
}

const AnimatedTable: FC<AnimatedTableProps> = ({ children, className = '' }) => {
    const tableRef = useRef<HTMLTableElement>(null);
    const [columnCount, setColumnCount] = useState(1);

    useLayoutEffect(() => {
        const count = tableRef.current?.querySelectorAll('thead th').length ?? 1;
        setColumnCount(Math.max(count, 1));
    }, [children]);

    return (
        <ExpandedRowProvider columnCount={columnCount}>
            <table ref={tableRef} className={className}>
                {children}
            </table>
        </ExpandedRowProvider>
    );
};

export default AnimatedTable;
